import * as React from 'react';
import { CSSProperties, useEffect, useState } from 'react';
import classNames from 'classnames';
import posed from 'react-pose';

import Button, { IButtonProps } from '../Button';

import IMPComponent from '../interfaces/IMPComponent';

import { UnsplashCollections } from '../../constants/unsplashCollections';

import defaultPlusImage from '../../assets/images/base64/default-plus-bg.jpg';

import './styles.scss';
import * as moment from 'moment';

interface INewPageButtonProps extends IMPComponent, IButtonProps {
  imageWidth: number;
  gray: boolean;
}

const Box = posed.div({
  hoverable: true,
  pressable: true,
  init: {
    scale: 1,
  },
  hover: {
    scale: 1.05,
    transition: { type: 'spring', stiffness: 100 },
  },
});

class DailyImageService {
  public unsplashClientId = 'fdd427aa85b4872a5634789aa5ae561d379a11c0bc7881a7ae0d57bb6de81499';
  public dailyImageKey: string = 'DAILY_IMAGE_KEY';

  public getTodayImage(): string | null {
    const storage = window.localStorage;
    const dailyImageJSON = storage.getItem(this.dailyImageKey);
    if (dailyImageJSON) {
      const image = JSON.parse(dailyImageJSON);
      if (image && moment(image.date).isSame(moment(), 'day')) {
        return image.url;
      }
    }

    return null;
  }

  public saveTodayImage(url: string) {
    const storage = window.localStorage;
    const imageRecord = JSON.stringify({
      url,
      date: moment().toDate(),
    });
    storage.setItem(this.dailyImageKey, imageRecord);
  }

  public async getDailyImageURL(collectionId: string, width: number) {
    const url = this.getTodayImage();
    if (url) {
      return url;
    }

    try {
      const response = await fetch(
        `https://api.unsplash.com/photos/random/?collections=${collectionId}&client_id=${this.unsplashClientId}`,
      );

      const jsonResponse = await response.json();

      const fetchedURL = `${jsonResponse.urls.raw}&w=${width}`;

      this.saveTodayImage(fetchedURL);

      return fetchedURL;
    } catch (error) {
      return defaultPlusImage;
    }
  }
}

const dailyImageService = new DailyImageService();

const NewPageButton = (props: INewPageButtonProps) => {
  const { className, gray, imageWidth, ...restProps } = props;
  const [data, setData] = useState({ backgroundImageURL: defaultPlusImage });

  useEffect(() => {
    const fetchData = async () => {
      const result = await dailyImageService.getDailyImageURL(UnsplashCollections.defaultCollection, imageWidth);

      setData({
        backgroundImageURL: result,
      });
    };

    fetchData();
  }, []);

  const cn = classNames('NewPageButton', className, {
    'NewPageButton--gray': gray,
  });

  const imageSrc = data.backgroundImageURL;

  const buttonStyles: CSSProperties = {
    backgroundImage: `url(${imageSrc})`,
  };

  return (
    <Box className={cn}>
      <div className="NewPageButton-inner" style={buttonStyles}>
        <Button
          iconName="plus-large"
          className="Button--transparent Button--circle Button--noPadding Button--fullWith Button--fullHeight"
          iconWidth={50}
          iconHeight={50}
          {...restProps}
        />
      </div>
    </Box>
  );
};

export default React.memo(NewPageButton);



// WEBPACK FOOTER //
// ./src/components/NewPageButton/index.tsx